import {
    formatDate,
    isNotNullOrEmptyObject,
    isNullOrEmptyArray,
    isNullOrEmptyObject,
} from "../../../shared/Utils";

// Date utility functions
export const getLastModifiedDate = (comment, file) => {
    if (isNullOrEmptyObject(comment)) {
        return file?.modified;
    } else if (isNullOrEmptyObject(file)) {
        return comment?.modified;
    } else {
        return comment?.modified > file?.modified ? comment?.modified : file?.modified;
    }
};

export const getCreatedDate = (comment, file) => {
    if (isNullOrEmptyObject(comment)) {
        return file?.created;
    } else if (isNullOrEmptyObject(file)) {
        return comment?.created;
    } else {
        return comment?.created < file?.created ? comment?.created : file?.created;
    }
};

export const getTime = date => {
    if (isNullOrEmptyObject(date)) {
        return "";
    }
    const time = date.split("T")[1];
    const [hours, minutes] = time.split(":");
    return `${hours}:${minutes}`;
};

// Pagination utility
export const calculatePagination = (currentPage, pageSize) => {
    return {
        top: pageSize,
        skip: (currentPage - 1) * pageSize,
    };
};

// Data mapping utility
export const mapApiDataToTableFormat = apiData => {
    if (isNullOrEmptyArray(apiData)) {
        return [];
    }

    const uniqueGroupIds = [...new Set(apiData.map(item => item.groupId))];

    const commentsAndFileGroups = uniqueGroupIds.map(groupId => {
        const groupData = apiData.filter(item => item.groupId === groupId);
        const groupComment = groupData.find(item => item.commentType === "COMMENT");
        const groupFile = groupData.find(item => item.commentType === "FILE");

        const selectedDate =
            getLastModifiedDate(groupComment, groupFile) || getCreatedDate(groupComment, groupFile);

        const result = {
            // NOTE: id is used for downloading file associated with it. For other operations we are using groupId
            id: groupFile?.id || groupComment?.id,
            groupId,
            user: groupComment?.accountName || groupFile?.accountName,
            date: formatDate({
                date: selectedDate,
                format: "en-US",
                includeTime: false,
                separator: "/",
            }),
            time: getTime(selectedDate),
            comment: isNotNullOrEmptyObject(groupComment) ? groupComment.entry : "-",
            file: isNotNullOrEmptyObject(groupFile) ? groupFile.entry : "",
        };

        return result;
    });

    return commentsAndFileGroups;
};
